import { useContext, useEffect, useState } from "react";
import trans, { isRTL } from "../../../utils";
import { filtrationcontext } from "../../../context/Filtercontext";
import { exportContext } from "../../../context/ExportDataContext";
import { useLazyGetMaintenanceReportsQuery } from "../../../Redux/service/NewReports/Reports";
import AntdTable from "../../antd/Table/Table";
import { useReportTableColumns } from "../ReportColumns/reportColumns";

const MaintenanceSheetTable = ({
  currentPage,
  setCurrentPage,
  isShown,
  setTotalData,
  selectedGroupIds,
  selectedVehicles,
  dueWithin,
}) => {
  const {
    setSort: setSortFilter,
    searchQuery,
    setSearchQuery,
    limit,
    setLimit,
  } = useContext(filtrationcontext);
  const {
    setFileName,
    setExportIds,
    setStartDateE,
    setEndDateE,
    setFilters,
  } = useContext(exportContext);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });
  const [trigger, { data, isFetching }] = useLazyGetMaintenanceReportsQuery();

  const columns = [
    {
      title: trans("Name"),
      dataIndex: "maintenanceName",
      width: 180,
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
      render: (value) => value || "-",
    },
    {
      title: trans("Type"),
      dataIndex: "type",
      width: 120,
      sorter: true,
      render: (value) => value || "-",
    },
    {
      title: trans("Vehicle"),
      dataIndex: "vehicle",
      width: 150,
      sorter: true,
      render: (value) => value || "-",
    },
    {
      title: trans("Driver"),
      dataIndex: "driver",
      width: 150,
      sorter: true,
      render: (value) => value || "-",
    },
    {
      title: trans("Group"),
      dataIndex: "group",
      width: 150,
      sorter: true,
      render: (value) => value || trans("Ungrouped Vehicles"),
    },
    {
      title: trans("Current"),
      dataIndex: "current",
      width: 120,
      sorter: true,
      render: (value) =>
        typeof value === "number" ? Number(value).toFixed(2) : "-",
    },
    {
      title: trans("Next Due"),
      dataIndex: "nextDue",
      width: 120,
      sorter: true,
      render: (value) => (typeof value === "number" ? value : "-"),
    },
    {
      title: trans("Remaining"),
      dataIndex: "remaining",
      width: 120,
      sorter: true,
      render: (value) =>
        typeof value === "number" ? Number(value).toFixed(2) : "-",
    },
    {
      title: trans("Status"),
      dataIndex: "status",
      width: 120,
      sorter: true,
      render: (value) => value || "-",
    },
  ];
  const visibleColumns = useReportTableColumns(columns);

  useEffect(() => {
    if (!isShown) {
      return;
    }
    const parts = [];
    if (
      typeof selectedGroupIds === "string" &&
      selectedGroupIds.trim().length > 0
    ) {
      parts.push(selectedGroupIds.trim());
    }
    if (selectedVehicles?.length > 0) {
      parts.push(
        selectedVehicles.map((id) => `vehicleId=${id}`).join("&"),
      );
    }
    if (
      dueWithin !== "" &&
      dueWithin !== null &&
      dueWithin !== undefined &&
      String(dueWithin).trim() !== ""
    ) {
      parts.push(`dueWithin=${encodeURIComponent(String(dueWithin).trim())}`);
    }
    if (searchQuery) {
      parts.push(`search=${encodeURIComponent(searchQuery)}`);
    }
    const filterQuery = parts.join("&");
    setFileName("Maintenance Report");
    setExportIds([]);
    setStartDateE("");
    setEndDateE("");
    setFilters(filterQuery);
  }, [
    isShown,
    selectedGroupIds,
    selectedVehicles,
    dueWithin,
    searchQuery,
    setFileName,
    setExportIds,
    setStartDateE,
    setEndDateE,
    setFilters,
  ]);

  useEffect(() => {
    if (isShown) {
      trigger(
        {
          page: currentPage,
          pageSize: limit,
          sortBy: sort.by,
          sortOrder: sort.order,
          search: searchQuery,
          selectedgroups:
            selectedGroupIds === undefined ? [] : selectedGroupIds,
          selectedVehicles,
          dueWithin,
        },
        true,
      );
    }
  }, [
    isShown,
    currentPage,
    limit,
    sort.by,
    sort.order,
    searchQuery,
    selectedGroupIds,
    selectedVehicles,
    dueWithin,
    trigger,
  ]);

  // useEffect(() => {
  //   if (data) {
  //     const list = data?.data || [];
  //     setTotalData([
  //       {
  //         title: "Total Maintenance Records",
  //         number: data?.count || list.length,
  //         type: "vehicles",
  //       },
  //       {
  //         title: "Due",
  //         number: list.filter((item) => item?.status === "Due").length,
  //         type: "time",
  //       },
  //       {
  //         title: "Not Due",
  //         number: list.filter((item) => item?.status === "Not Due").length,
  //         type: "time",
  //       },
  //     ]);
  //   }
  // }, [data, setTotalData]);

  useEffect(() => {
    return () => {
      setSortFilter({ type: "", value: "" });
      localStorage.setItem("page", 1);
      setSearchQuery("");
    };
  }, [setSortFilter, setSearchQuery]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      setSort({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      setSort({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <AntdTable
        columns={visibleColumns}
        dataSource={data?.data || []}
        loading={isFetching}
        pageSize={limit}
        totalItems={data?.paginationInfo?.totalItems || 0}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={350}
      />
    </div>
  );
};

export default MaintenanceSheetTable;
